<template>
  <div>
    <div id="current-order-info">
      <div class="order-tip">
        <p>订单信息</p>
        <b-table :fields="fields" />
      </div>
      <div v-if="orders" class="order-content">
        <div v-for="(order,index) in orders" :key="index">
          <order-list :order="order" @showModal="showModal" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import OrderList from './OrderList'
export default {
  components: {
    'order-list': OrderList
  },
  props: {
    orders: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      fields: [
        { key: 'image', label: '图片' }, { key: 'name', label: '通用名/商品名' },
        { key: 'norm', label: '规格' }, { key: 'maker', label: '生产厂家' },
        { key: 'licenseNumber', label: '批准文号' }, { key: 'largeScale', label: '大包装' },
        { key: 'lotNumber', label: '批号' }, { key: 'expiryTime', label: '有效期至' },
        { key: 'basicUnit', label: '单位' }, { key: 'showPrice', label: '单价' },
        { key: 'num', label: '数量' }, { key: 'count', label: '小计' },
        '资质文件'
      ]
    }
  },
  methods: {
    showModal (url) {
      this.$emit('showModal', url)
    }
  }
}
</script>
<style>
  #current-order-info {
    font-size: 0.75rem;
  }
  #current-order-info p {
    text-align: left;
    font-size: 1rem;
    line-height: 30px;
  }
  #current-order-info .table {
    margin-bottom: 0;
  }
  #current-order-info .table thead {
    background-color: #fff;
    height: 30px;
    box-sizing: border-box;
    font-size: 0.875rem;
  }
  #current-order-info .table thead th {
    border: 0;
    font-weight: normal;
    height: 30px;
    padding: 0;
    vertical-align: middle;
  }
  .order-tip .table thead th:nth-child(1){
    width: 50px;
  }
  .order-tip .table thead th:nth-child(2){
    width: 140px;
  }
  .order-tip .table thead th:nth-child(3){
    width: 70px;
  }
  .order-tip .table thead th:nth-child(4){
    width: 120px;
  }
  .order-tip .table thead th:nth-child(5){
    width: 100px;
  }
  .order-tip .table thead th:nth-child(6){
    width: 80px;
  }
  .order-tip .table thead th:nth-child(7){
    width: 90px;
  }
  .order-tip .table thead th:nth-child(8){
    width: 100px;
  }
  .order-tip .table thead th:nth-child(9){
    width: 50px;
  }
  .order-tip .table thead th:nth-child(10){
    width: 80px;
  }
  .order-tip .table thead th:nth-child(11){
    width: 100px;
  }
  .order-tip .table thead th:nth-child(12){
    width: 80px;
  }
  .order-tip .table thead th:nth-child(13){
    width: 140px;
  }
</style>
